import { MessageDescriptor, useIntl } from 'react-intl';

export const useIntlMessage = (descriptor: MessageDescriptor, values?: Record<string, string | number>): string => {
	const intl = useIntl();

	return intl.formatMessage(descriptor, values);
};
